import React, { useEffect } from "react";
import SubVisual from "../../components/SubVisual";
import * as S from "./styled";
import subVisualQualifications from "../../assets/subVisual/subVisualQualifications.png";
import { qualificationsLists } from "../../data/qualifications";
import KakaoIcon from "../../assets/images/qualifications/qualificationsKakaoIcon.png";
import CallIcon from "../../assets/images/qualifications/qualificationsCallIcon.png";
import Icon from "../../components/Icon";
import { NavLink } from "react-router-dom";
import mainSlideArrowRightIcon from "../../assets/images/home/mainSlideArrowRight.png";
import Aos from "aos";
import { Helmet } from "react-helmet-async";

const Qualifications = () => {
  const handleCopyPhoneNumber = () => {
    const phoneNumber = "010-2351-8784";
    navigator.clipboard
      .writeText(phoneNumber)
      .then(() => {})
      .catch((err) => {
        console.error("복사 실패: ", err);
      });
  };
  useEffect(() => {
    if (typeof window === "undefined") return;

    const isReactSnap = navigator.userAgent === "ReactSnap";

    if (!isReactSnap) {
      Aos.init();
      window.scrollTo(0, 0);
    } else {
      window.scrollTo(0, document.body.scrollHeight);
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>IPDIA 국제실용댄스지도자협회</title>

        <meta
          name="description"
          content="전문 댄스강사 양성 및 실용무용 교육과 네트워크를 선도하는 국제실용댄스지도자협회입니다."
        />

        <meta
          name="keywords"
          content="IPDIA, 아이피디아, 국제실용댄스지도자협회, 국제실용댄스, 셔플댄스, 댄스협회, 댄스자격증, 실용무용, 댄스강사자격증"
        />

        <meta property="og:title" content="넵튠 댄스 스튜디오" />
        <meta
          property="og:description"
          content="전문 댄스강사 양성 및 실용무용 교육과 네트워크를 선도하는 국제실용댄스지도자협회입니다."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="http://ipdiakorea.com" />
        <meta
          property="og:image"
          content="http://ipdiakorea.com/og-image.png"
        />
      </Helmet>
      <S.QualificationsContainer>
        <SubVisual
          src={subVisualQualifications}
          title="셔플댄스 지도자 자격증"
          subTitle="자격 검정 안내"
        />
        <S.QualificationsWrapper>
          <div className="inner">
            <S.QualificationsWrap>
              <S.QualificationsListWrap>
                {qualificationsLists.map((item, index) => (
                  <li
                    data-aos="fade"
                    data-aos-duration={800}
                    data-aos-delay={(index + 1) * 300}
                    data-aos-easing="linear"
                  >
                    <h4>{item.title}</h4>
                    <div className="title-text-wrap">
                      {item.texts.map((text) => (
                        <p>{text}</p>
                      ))}
                    </div>
                    <div>
                      <dl>
                        <dt>신청대상</dt>
                        <dd>
                          {item.targets.map((target) => (
                            <p>{target}</p>
                          ))}
                        </dd>
                      </dl>
                      <dl>
                        <dt>커리큘럼</dt>
                        <dd>
                          {item.curriculums.map((curriculum) => (
                            <p>{curriculum}</p>
                          ))}
                        </dd>
                      </dl>
                      <dl>
                        <dt>교육목표</dt>
                        <dd>
                          {item.goals.map((goal) => (
                            <p>{goal}</p>
                          ))}
                        </dd>
                      </dl>
                    </div>
                  </li>
                ))}
              </S.QualificationsListWrap>
              <S.QualificationsInfoWrap
                data-aos="fade"
                data-aos-duration={600}
                data-aos-easing="linear"
              >
                <div className="text-wrap">자격증 정보</div>
                <ul className="info-wrap">
                  <li>
                    <p>자격증명: 셔플댄스지도자 자격</p>
                    <p>교육기관: 국제실용댄스지도자협회</p>
                    <p>등록번호: 2024-006376</p>
                    <p>주무부처: 문화체육관광부</p>
                  </li>
                  <li>
                    <p>검정방법: 필기/실기</p>
                    <p>등급: 1급, 2급, 3급</p>
                    <p>발급형태: 상장형</p>
                    <p>교육장소: IPDIA 서울본부센터</p>
                  </li>
                </ul>
              </S.QualificationsInfoWrap>
            </S.QualificationsWrap>
          </div>
        </S.QualificationsWrapper>
        <S.QualificationsContactusWrapper>
          <div className="inner">
            <S.QualificationsContactusWrap>
              <li
                data-aos="fade-up"
                data-aos-duration={800}
                data-aos-easing="linear"
              >
                <NavLink to="http://pf.kakao.com/_xdxcJZn" target="_blank">
                  <Icon>
                    <img src={KakaoIcon} alt="logo" />
                  </Icon>
                  <div>
                    <div className="text-wrap">
                      <h6>온라인 상담 문의</h6>
                      <p>카카오상담 바로가기</p>
                    </div>
                    <Icon>
                      <img src={mainSlideArrowRightIcon} alt="logo" />
                    </Icon>
                  </div>
                </NavLink>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration={800}
                data-aos-dealy={300}
                data-aos-easing="linear"
              >
                <button onClick={handleCopyPhoneNumber} className="pc-button">
                  <Icon>
                    <img src={CallIcon} alt="logo" />
                  </Icon>
                  <div>
                    <div className="text-wrap">
                      <h6>전화 상담 문의</h6>
                      <p>010-2351-8784</p>
                    </div>
                    <Icon>
                      <img src={mainSlideArrowRightIcon} alt="logo" />
                    </Icon>
                  </div>
                </button>
                <a href="tel:010-2351-8784" className="mobile-button">
                  <Icon>
                    <img src={CallIcon} alt="logo" />
                  </Icon>
                  <div>
                    <div className="text-wrap">
                      <h6>전화 상담 문의</h6>
                      <p>010-2351-8784</p>
                    </div>
                    <Icon>
                      <img src={mainSlideArrowRightIcon} alt="logo" />
                    </Icon>
                  </div>
                </a>
              </li>
            </S.QualificationsContactusWrap>
          </div>
        </S.QualificationsContactusWrapper>
      </S.QualificationsContainer>
    </>
  );
};

export default Qualifications;
